<app-modal-add-personal
  [driverInfo]="driverInfo"
  (driverUpdated)="onDriverUpdated()"
></app-modal-add-personal>
